<template>
  <div>
    <b-navbar
      fixed="top"
      toggleable="lg"
      variant="white"
      class="px-2 py-2 top-navbar"
    >
      <b-container class="custom-container my-0">
        <b-navbar-brand
          class="d-lg-block d-none hidden-temp"
          :to="{ name: 'home.welcome-page' }"
        >
          <b-img
            v-bind="avatarProps"
            rounded
            alt="Logo"
            class=""
            src="/img/logo.svg"
          ></b-img>
        </b-navbar-brand>

        <b-navbar-toggle
          target="nav-collapse"
          class="border-0"
        ></b-navbar-toggle>

        <b-navbar-nav class="d-lg-none d-flex align-items-center flex-row mx-0">
          <b-nav-item-dropdown
            right
            lazy
            no-caret
            variant="link"
            toggle-class="px-0 text-decoration-none text-lg-left text-center"
            menu-class="py-0 my-0 position-absolute user-dropdown-menu-container"
            class="px-2 mr-2 user-dropdown"
          >
            <template #button-content>
              <b-button variant="primary">
                <b-icon-plus
                  font-scale="1.5"
                  class="align-middle"
                ></b-icon-plus>
                <span class="align-middle">New</span>
              </b-button>
            </template>

            <b-dropdown-item
              :to="{ name: 'templates.list-page' }"
              link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
              class="align-middle border-bottom user-dropdown-item"
            >
              <b-img
                :src="require('@/assets/icons/file.svg')"
                class="mr-3"
                width="20px"
                height="20px"
              ></b-img
              ><small>File</small></b-dropdown-item
            >
            <b-dropdown-item
              v-if="!isTradieUser"
              :to="{ name: 'request.templates-page' }"
              link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
              class="align-middle border-bottom user-dropdown-item"
              ><b-img
                :src="require('@/assets/icons/request.svg')"
                class="mr-3"
                width="20px"
                height="20px"
              ></b-img
              ><small>Requests</small></b-dropdown-item
            >
          </b-nav-item-dropdown>
          <b-nav-item class="px-2">
            <div class="p-relative">
              <b-img
                :src="
                  hover
                    ? require('@/assets/icons/bell.svg')
                    : require('@/assets/icons/bell-black.svg')
                "
                @mouseover="hover = true"
                @mouseleave="hover = false"
                @click="setShowNotificationList()"
              ></b-img>
              <b-badge variant="danger" class="badge">{{
                unreadNotifications.length > 0 ? unreadNotifications.length : ''
              }}</b-badge>
            </div>
          </b-nav-item>
          <b-nav-item-dropdown
            right
            lazy
            no-caret
            variant="link"
            toggle-class="px-0 text-decoration-none text-lg-left text-center"
            menu-class="py-0 my-0 position-absolute user-dropdown-menu-container"
            class="px-2 mr-2 user-dropdown"
          >
            <template #button-content>
              <b-avatar
                button
                v-if="userAvatar"
                variant="light"
                :src="userAvatar"
              ></b-avatar>
              <b-avatar
                button
                v-else
                variant="primary"
                :text="userInitials"
              ></b-avatar>
              <div v-if="user" class="d-none ml-lg-2 align-middle">
                {{ user.full_name }}
              </div>
            </template>
            <b-dropdown-item
              :to="{ name: 'user.settings-page' }"
              link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
              class="align-middle border-bottom user-dropdown-item"
            >
              <b-icon icon="gear" class="mr-3"></b-icon>
              <small>My Account</small>
            </b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'premium.subscription' }"
              link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
              class="align-middle border-bottom user-dropdown-item"
            >
              <b-img
                fluid
                alt="Tradie Pass Premium"
                class="mr-3"
                :src="require('@/assets/icons/king.svg')"
                :style="'width: 20px; height: 20px;'"
              ></b-img>
              <small>Tradie Pass Premium</small>
            </b-dropdown-item>
            <b-dropdown-item
              href="javascript:void(0)"
              link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
              class="align-middle border-bottom user-dropdown-item"
              @click="signOut()"
            >
              <b-icon icon="box-arrow-right" class="mr-3"></b-icon>
              <small>Logout</small>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="m-auto">
            <b-nav-item
              class="d-lg-none d-flex px-4 py-3"
              :to="{ name: 'home.welcome-page' }"
            >
              <b-img
                v-bind="avatarProps"
                rounded
                alt="Logo"
                class=""
                src="/img/logo.svg"
              ></b-img>
            </b-nav-item>
            <b-nav-item
              class="px-4 py-3"
              :active="isActive('home.welcome-page')"
              :to="{ name: 'home.welcome-page' }"
              >Home
            </b-nav-item>
            <b-nav-item
              class="px-4 py-3"
              :active="isActive('file.list-page')"
              :to="{ name: 'file.list-page' }"
              >Files</b-nav-item
            >
            <b-nav-item
              class="px-4 py-3"
              :active="isActive('requests.list-page')"
              :to="{ name: 'requests.list-page' }"
              >Requests</b-nav-item
            >
          </b-navbar-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="d-lg-flex d-none align-items-center">
            <b-nav-item-dropdown
              right
              lazy
              no-caret
              variant="link"
              toggle-class="px-0 text-decoration-none text-lg-left text-center"
              menu-class="py-0 my-0 position-absolute user-dropdown-menu-container"
              class="px-2 mr-2 user-dropdown"
            >
              <template #button-content>
                <b-button variant="primary">
                  <b-icon-plus
                    font-scale="1.5"
                    class="align-middle"
                  ></b-icon-plus>
                  <span class="align-middle">New</span>
                </b-button>
              </template>

              <b-dropdown-item
                :to="{ name: 'templates.list-page' }"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
              >
                <b-img
                  :src="require('@/assets/icons/file.svg')"
                  class="mr-3"
                  width="20px"
                  height="20px"
                ></b-img
                ><small>File</small></b-dropdown-item
              >
              <b-dropdown-item
                v-if="!isTradieUser"
                :to="{ name: 'request.templates-page' }"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
                ><b-img
                  :src="require('@/assets/icons/request.svg')"
                  class="mr-3"
                  width="20px"
                  height="20px"
                ></b-img
                ><small>Requests</small></b-dropdown-item
              >
            </b-nav-item-dropdown>
            <b-nav-item>
              <div class="p-relative">
                <b-img
                  :src="
                    hover
                      ? require('@/assets/icons/bell.svg')
                      : require('@/assets/icons/bell-black.svg')
                  "
                  @mouseover="hover = true"
                  @mouseleave="hover = false"
                  @click="setShowNotificationList()"
                ></b-img>
                <b-badge variant="danger" class="badge">{{
                  unreadNotifications.length > 0
                    ? unreadNotifications.length
                    : ''
                }}</b-badge>
              </div>
            </b-nav-item>
            <b-nav-item-dropdown
              right
              lazy
              no-caret
              variant="link"
              toggle-class="px-0 text-decoration-none text-lg-left text-center"
              menu-class="py-0 my-0 user-dropdown-menu-container"
              class="ml-lg-3 user-dropdown"
            >
              <template #button-content>
                <b-avatar
                  button
                  v-if="userAvatar"
                  variant="light"
                  :src="userAvatar"
                ></b-avatar>
                <b-avatar
                  button
                  v-else
                  variant="primary"
                  :text="userInitials"
                ></b-avatar>
                <div
                  v-if="user"
                  class="d-xl-none d-lg-none ml-lg-2 align-middle"
                >
                  {{ user.full_name }}
                </div>
              </template>
              <b-dropdown-item
                :to="{ name: 'user.settings-page' }"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
              >
                <b-icon icon="gear" class="mr-3"></b-icon>
                <small>My Account</small>
              </b-dropdown-item>
              <b-dropdown-item
                :to="{ name: 'premium.subscription' }"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
              >
                <!-- <b-icon icon="crown" class="mr-3"></b-icon> -->
                <b-img
                  :src="require('@/assets/icons/king.svg')"
                  class="mr-3"
                  width="20px"
                  height="20px"
                ></b-img>
                <small>Tradie Pass Premium</small>
              </b-dropdown-item>
              <b-dropdown-item
                href="javascript:void(0)"
                link-class="d-flex px-3 py-2 align-middle text-wrap user-dropdown-link"
                class="align-middle border-bottom user-dropdown-item"
                @click="signOut()"
              >
                <b-icon icon="box-arrow-right" class="mr-3"></b-icon>
                <small>Logout</small>
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

    <notifications-list
      v-if="showNotificationList"
      @close="closeNotificationList"
    ></notifications-list>

    <b-overlay
      rounded="sm"
      opacity="0.5"
      blur="1rem"
      spinner-variant="primary"
      id="overlay-background"
      class="min-vh-100"
      :show="show"
    >
      <div
        class="slot-container p-0 m-0 full-width gray--bg"
        :aria-hidden="show ? 'true' : null"
      >
        <router-view />
        <footer-section />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import FooterSection from '@/components/FooterSection'
import NotificationsList from '@/components/lists/NotificationsList'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    FooterSection,
    NotificationsList
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      device: state => state.device.deviceDetails
    }),

    userAvatar() {
      return this.user && this.user.avatar ? this.user.avatar.url : ''
    },

    userInitials() {
      return this.user && this.user.full_name
        ? this.user.full_name
            .match(/(^\S\S?|\b\S)?/g)
            .join('')
            .match(/(^\S|\S$)?/g)
            .join('')
            .toUpperCase()
        : ''
    },

    isTradieUser() {
      return this.user ? this.user.user_type === 'tradie' : false
    },

    ...mapGetters('notification', ['notifications', 'unreadNotifications'])
  },

  data() {
    return {
      show: false,
      avatarProps: {
        height: 36
      },
      hover: false,
      showNotificationList: false
    }
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
      getAuthenticatedUser: 'auth/getAuthenticatedUser',
      getNotifications: 'notification/getNotifications',
      getUnreadNotifications: 'notification/getUnreadNotifications'
    }),

    signOut() {
      if (window.gapi) {
        window.gapi.auth2.getAuthInstance().signOut()
      }
      if (window.FB) {
        window.FB.logout()
      }
      this.logout()
    },

    newFilePage() {
      this.$router.replace({ name: 'templates.list-page' })
    },

    async getUserNotifications() {
      await this.getUnreadNotifications()
      await this.getNotifications()
    },

    setShowNotificationList() {
      this.showNotificationList = this.showNotificationList !== true
    },

    closeNotificationList() {
      this.showNotificationList = false
      this.getUserNotifications()
    },

    isActive(page) {
      return page === this.$route.name
    }
  },

  async created() {
    this.show = true
    await this.getAuthenticatedUser()
    this.show = false
    this.getUserNotifications()

    const tradieRestrictedRoutePaths = [
      'request.templates-page',
      'request.new-page',
      'request.view-requested-to-page',
      'request.edit-requested-to-page'
    ]

    if (
      this.isTradieUser &&
      tradieRestrictedRoutePaths.includes(this.$route.matched[1].name)
    ) {
      this.$router.replace({ name: 'page-not-found' })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/main';

.top-navbar {
  // position: fixed;
  width: 100%;
  // min-width: 960px;
  z-index: 99;
  box-shadow: 0px 3px 5px #00429d0d;

  /deep/ .user-dropdown-link {
    &:hover,
    &:focus,
    &:active {
      background-color: #eaf3ff !important;
      color: #006cff !important;
    }
  }
  /deep/ .nav-item.nav-item.nav-item {
    font-weight: bolder;
    &:hover,
    &:focus,
    &:active {
      background-color: #eaf3ff !important;
    }
    a {
      &:hover,
      &:focus,
      &:active {
        color: #006cff !important;
      }
    }
  }
}
.btn {
  height: 48px;
  padding: 4px 12px 4px 10px;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.slot-container {
  height: 100%;
}
.nav-button {
  height: 36px;
  margin-right: 30px;
}
.mw-300 {
  min-width: 300px;
}
.bp-menu-icon {
  width: 24px;
  height: 24px;
  color: #2c66d5;
  vertical-align: middle !important;
}
.hidden-temp {
  @media (max-width: 767px) {
    display: none;
  }
}
.align-middle {
  vertical-align: middle;
}
.badge {
  position: absolute;
  transform: translateY(50%);
  border: 3px solid;
  border-radius: 50%;
  bottom: 25px;
  left: 12px;
}
/deep/ .user-dropdown-menu-container {
  width: 12em;
}
.active {
  color: #006cff !important;
}
</style>
